import AimlabsMarketplace from "./aimlabs-marketplace/aimlabs-marketplace.module"
import Notifications from "./notifications/notifications.module"

const state = {}
const mutations = {}
const actions = {}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    AimlabsMarketplace,
    Notifications,
  },
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/dashboard.module.js